.root {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  width: max-content;
  padding: 0 2rem;
  font-family: inherit;
  font-size: var(--font-size-button);
  font-weight: var(--font-weight-regular);
  letter-spacing: var(--font-small-letter-spacing);
  text-decoration: none;
  cursor: pointer;
  border-color: transparent;
  border-style: solid;
  border-width: 1px;
  border-radius: 100px;
  transition:
    border-color 0.15s ease-out,
    background-color 0.15s ease-out,
    color 0.15s ease-out;

  span {
    /** offsetting by a pixel fixes the funky optical centering with lowercase letters */
    transform: translateY(1px);
  }

  &.hasBeforeIcon {
    padding-right: 1.5rem;
    padding-left: 1.25rem;
  }

  &.hasAfterIcon {
    padding-right: 1.25rem;
    padding-left: 1.5rem;
  }

  &:hover {
    text-decoration: none;
  }

  &:focus {
    outline: none;
  }

  &[aria-disabled="true"] {
    &,
    &:active,
    &:hover,
    &:focus {
      color: var(--gray-700);
      cursor: not-allowed;
      background: var(--gray-300);
      border: 1px solid var(--gray-400);
    }
  }
}

/* Variants */
.primary {
  color: #ffffff;
  background-color: #000000;
  border-color: #000000;

  &:hover {
    color: #ffffff;
    background-color: #333333;
    border-color: #333333;
  }

  &:focus-visible {
    outline: thick double black;
  }
}

.secondary {
  color: var(--on-background);
  background-color: transparent;
  border-color: var(--gray-300);

  &:hover {
    background-color: var(--gray-200);
    border-color: var(--gray-400);
  }

  &:focus-visible {
    outline: thick double black;
  }
}

.tertiary {
  color: var(--on-background);
  background-color: transparent;

  &:focus-visible {
    outline: thick double black;
  }

  &:hover {
    color: black;
    background: var(--gray-200);
  }

  &[aria-disabled="true"] {
    &,
    &:hover,
    &:active,
    &:focus {
      color: var(--gray-500);
      background: transparent;
      border-color: transparent;
    }
  }
}

/* Sizes */
.sm {
  height: 28px;
  line-height: 26px;
}

.md {
  height: var(--form-item-base-height);
  line-height: 38px; /* same as button height (-border) - vertical padding works magically */
}

.lg {
  height: 48px;
  line-height: 46px;
}

/* Misc */
.iconWithoutContent {
  width: var(--form-item-base-height);
  height: var(--form-item-base-height);
  padding: 0;
}

.block {
  width: 100%;
}

.icon {
  display: inline-block;
  width: 21px;

  &.rotated {
    transform: rotate(-180deg);
  }
}
